"use client";

import { css } from "styled-system/css";
import { flex, stack } from "styled-system/patterns";

import { DecibelLogoWordmark } from "@/components/vectors/decibel-logo-wordmark";

interface SeasonHeroHeaderProps {
  season: string;
  title: string;
}

export function SeasonHeroHeader({ season, title }: SeasonHeroHeaderProps) {
  return (
    <div className={stack({ gap: "2", pb: "0" })}>
      <div className={wordMarkHeaderStyles}>
        <DecibelLogoWordmark
          className={css({
            h: "20",
            w: "auto",
          })}
        />
        <span className={seasonTextStyles}>{season}</span>
      </div>
      <span className={titleStyles}>{title}</span>
    </div>
  );
}

const wordMarkHeaderStyles = flex({
  gap: "8",
  py: "2",
  align: "flex-end",
  justify: "center",
  fontWeight: "light",
});

const seasonTextStyles = css({
  textStyle: "body.xl",
  fontWeight: "light",
  fontVariantNumeric: "lining-nums tabular-nums slashed-zero",
  color: "text.secondary",
});

const titleStyles = css({
  textStyle: "subheading.md",
  fontWeight: "book",
  fontVariantNumeric: "lining-nums tabular-nums",
  mx: "auto",
});
